import React from "react";
import { Link } from "react-router-dom";
import { Shield, ArrowLeft, Zap, Mail } from "lucide-react";

export default function Privacy() {
  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[480px] grid-bg radial-fade opacity-30" />
      <div className="pointer-events-none absolute -top-40 -right-40 h-96 w-96 rounded-full bg-primary/20 blur-3xl" />

      <header className="relative border-b border-border bg-card/40 backdrop-blur">
        <div className="mx-auto max-w-5xl flex items-center justify-between px-5 h-14">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary text-primary-foreground neon-primary">
              <Zap className="h-4 w-4" />
            </span>
            <span className="font-display text-base font-bold tracking-tight">
              Video<span className="gradient-text">Lens</span>
            </span>
          </Link>
          <Link
            to="/dashboard"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> Back to app
          </Link>
        </div>
      </header>

      <main className="relative mx-auto max-w-3xl px-5 pt-10 pb-24 sm:pt-16" data-testid="privacy-page">
        <div className="inline-flex items-center gap-2 rounded-full border border-border bg-card/60 px-3 py-1 text-[11px] text-muted-foreground backdrop-blur">
          <Shield className="h-3.5 w-3.5 text-primary" />
          <span className="overline">Legal</span>
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight mt-4">
          Privacy Policy
        </h1>
        <p className="text-sm text-muted-foreground mt-3 max-w-xl">
          Our full Privacy Policy is being finalised. If you have questions about how VideoLens
          handles your account information in the meantime, please contact us.
        </p>

        <div className="mt-10 rounded-2xl border border-border bg-card/40 backdrop-blur p-6 space-y-3 text-sm">
          <p className="overline text-muted-foreground">Interim notice</p>
          <p>
            VideoLens stores the account information you provide (such as your name, email and
            a password hash) and the YouTube URLs and resulting AI-generated analyses you
            create while using the Service. Payments are processed by a third-party payment
            processor (currently Razorpay); we do not store full card numbers or complete
            bank-account credentials on our servers.
          </p>
          <p>
            A complete Privacy Policy describing what personal data we collect, how it is used,
            how long it is retained and your rights in respect of that data will be published
            on this page.
          </p>
          <p className="text-xs text-muted-foreground pt-2 border-t border-border">
            Effective Date: <span className="tabular">[Insert Date]</span>
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-2 text-[11px]">
          <Link
            to="/terms"
            data-testid="privacy-terms-link"
            className="inline-flex items-center gap-1 rounded-full border border-border bg-card/60 px-2.5 py-1 text-muted-foreground hover:text-foreground transition-colors"
          >
            Terms &amp; Conditions
          </Link>
          <a
            href="mailto:[Insert official support email]"
            className="inline-flex items-center gap-1 rounded-full border border-border bg-card/60 px-2.5 py-1 text-muted-foreground hover:text-foreground transition-colors"
          >
            <Mail className="h-3 w-3" /> Contact
          </a>
        </div>
      </main>
    </div>
  );
}
